import classnames from 'classnames';
import arrowRightFromBase from '@ingka/ssr-icon/paths/arrow-right-from-base';
import { isCiamEnabled } from '../../../../utils/retailUnitsWithCiam';
import ListView, { ListViewItem } from '@ingka/list-view';
import { PREFIX } from '../../../Skapa/constants/constants';
import { useTranslation } from 'react-i18next';
import styles from './LogoutButton.module.scss';
import { useMemo } from 'react';
import { toUrl, getAuthServiceUrl } from '../../../../utils/url';
import { getRetailUnitAndLanguage } from '../../../../network/utils/getRetailUnitAndLanguage';

export const LogoutButton = ({ logout, standalone }: { logout: () => void; standalone?: boolean }) => {
  const { t } = useTranslation('profile');

  const logoutHref = useMemo(() => {
    const { retailUnit, language } = getRetailUnitAndLanguage();

    return toUrl(`${getAuthServiceUrl()}/logout`, {
      lang: language,
      retailUnit: retailUnit,
      referrer: globalThis.location.href,
    });
  }, []);

  const component = isCiamEnabled ? (
    <ListViewItem
      className={classnames(styles.logoutButton, {
        [styles.standalone]: standalone,
      })}
      prefix={PREFIX}
      title={t('generic.logOut.linkText')}
      href={logoutHref}
      showDivider={false}
      controlIcon={null}
      leadingIcon={arrowRightFromBase}
      control="link"
    />
  ) : (
    <ListViewItem
      className={classnames(styles.logoutButton, {
        [styles.standalone]: standalone,
      })}
      prefix={PREFIX}
      title={t('generic.logOut.linkText')}
      onClick={() => logout() /*if we just write logout here event gets passed as argument*/}
      showDivider={false}
      controlIcon={null}
      leadingIcon={arrowRightFromBase}
      control="navigational"
    />
  );

  if (standalone) {
    return (
      <ListView id="standaloneLogoutButton" prefix={PREFIX} showDivider={false}>
        {component}
      </ListView>
    );
  }

  return component;
};
